module.exports = __webpack_public_path__ + "img/ico_pdf.3ed4f058.svg";